import React from 'react';
import { useTranslation } from 'react-i18next';
import { routes } from '../../static/routes';
import { colors } from '../../styles/variables';
import ActiveGameIcon from '../icons/ActiveGameIcon';
import CalendarIcon from '../icons/CalendarIcon';
import DashboardIcon from '../icons/DashboardIcon';
import GameIcon from '../icons/GameIcon';
import MobileAppVersionIcon from '../icons/MobileAppVersionIcon';
import PartnersIcon from '../icons/PartnersIcon';
import QuestionsNavIcon from '../icons/QuestionsNavIcon';
import SubscriptionsIcon from '../icons/SubscriptionsIcon';
import { Navbar } from '../navigation/Navbar';
import NavButton from '../navigation/components/NavButton';
import NavButtonAccount from '../navigation/components/NavButtons/NavButtonAccount';
import NavButtonLogout from '../navigation/components/NavButtons/NavButtonLogout';
import LayoutWrapper from './LayoutWrapper';

export interface LayoutGlobalAdminProps {
  children: React.ReactNode;
}

// TODO: consider refactor of all layouts - depending on the user type content
export const LayoutGlobalAdmin = (props: LayoutGlobalAdminProps) => {
  const { children } = props;
  const { t } = useTranslation();

  const buttonsTop = (
    <>
      <NavButton
        href={routes.dashboard}
        text={t('navigation.dashboard')}
        icons={{
          default: <DashboardIcon width={24} height={24} />,
          active: <DashboardIcon color={colors.white900} width={24} height={24} />,
        }}
      />
      <NavButton
        href={routes.partners}
        text={t('navigation.partners')}
        icons={{
          default: <PartnersIcon width={24} height={24} />,
          active: <PartnersIcon color={colors.white900} width={24} height={24} />,
        }}
      />
      <NavButton
        href={routes.bundles}
        text={t('navigation.subscription-bundles')}
        icons={{
          default: <SubscriptionsIcon width={24} height={24} />,
          active: <SubscriptionsIcon color={colors.white900} width={24} height={24} />,
        }}
      />
      <NavButton
        href={routes.activeGames}
        text={t('navigation.active-games')}
        icons={{
          default: <ActiveGameIcon width={24} height={24} />,
          active: <ActiveGameIcon color={colors.white900} width={24} height={24} />,
        }}
      />
      <NavButton
        href={routes.activeIndividualGames}
        text={t('navigation.active-individual-games')}
        icons={{
          default: <ActiveGameIcon width={24} height={24} />,
          active: <ActiveGameIcon color={colors.white900} width={24} height={24} />,
        }}
      />
      <NavButton
        href={routes.questions()}
        text={t('navigation.questions')}
        icons={{
          default: <QuestionsNavIcon width={24} height={24} />,
          active: <QuestionsNavIcon color={colors.white900} width={24} height={24} />,
        }}
      />
      <NavButton
        href={routes.templates()}
        text={t('navigation.templates')}
        icons={{
          default: <GameIcon width={24} height={24} />,
          active: <GameIcon color={colors.white900} width={24} height={24} />,
        }}
      />
      <NavButton
        href={routes.historyGames}
        text={t('navigation.history-games')}
        icons={{
          default: <CalendarIcon width={24} height={24} />,
          active: <CalendarIcon color={colors.white900} width={24} height={24} />,
        }}
      />
      <NavButton
        href={routes.allGamers()}
        text={t('navigation.all-gamers')}
        icons={{
          default: <GameIcon />,
          active: <GameIcon color={colors.white900} />,
        }}
      />
      <NavButton
        href={routes.mobileAppVersion}
        text={t('navigation.mobile-app-version')}
        icons={{
          default: <MobileAppVersionIcon />,
          active: <MobileAppVersionIcon color={colors.white900} />,
        }}
      />
    </>
  );

  const buttonsBottom = (
    <>
      <NavButtonAccount />
      <NavButtonLogout />
    </>
  );
  return (
    <LayoutWrapper navbar={<Navbar buttonsTop={buttonsTop} buttonsBottom={buttonsBottom} />}>{children}</LayoutWrapper>
  );
};

export default LayoutGlobalAdmin;
